import script from "./CustomerFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerFilters.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerFilters.vue?vue&type=style&index=0&id=36aa2942&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36aa2942"]])

export default __exports__